import { useEffect, useMemo, useRef } from 'react';

import { breakpoint } from '@/constants/breakpoint';

import useWindowSize from './useWindowSize';

export const useStickyToHeaderBottom = (defaultTopPosition = '0px') => {
  const stickyTopPositionRef = useRef<HTMLDivElement>(null);
  const windowWidth = useWindowSize().width || 0;
  const isMobile = useMemo(
    () => (windowWidth ? windowWidth < breakpoint.md : false),
    [windowWidth],
  );
  useEffect(() => {
    const handleScroll = () => {
      const headers = document.getElementById('global-headers');
      const headersBottom = headers?.getBoundingClientRect().bottom ?? 0;
      const clampedBottom = Math.max(0, headersBottom);
      const clampedBottomPx = clampedBottom + 'px';
      if (
        stickyTopPositionRef.current &&
        stickyTopPositionRef.current.style.top !== clampedBottomPx
      ) {
        stickyTopPositionRef.current.style.top = isMobile ? defaultTopPosition : clampedBottomPx;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [defaultTopPosition, isMobile]);

  return { stickyTopPositionRef };
};
